// Randomizes the floating-ice decoration (snippets/seal-floating-ice.liquid)
// on load: shuffles which floe shape occupies which position slot, so the
// arrangement is genuinely different per page view rather than a fixed
// pattern. If this script fails to run (disabled JS, error), the Liquid
// markup's own fixed shapes/positions still render as a static fallback.

/**
 * @param {HTMLElement[]} items
 */
function shuffle(items) {
  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [items[i], items[j]] = [items[j], items[i]];
  }
  return items;
}

// Shuffles shapes only within their own pool (data-pool) — the "edge" pool
// (small, normalized to a 70px max dimension) and "column" pool (larger,
// normalized to 130px) are sized for their own slots' spacing, so a shape
// must never cross between pools or it could overlap its new neighbors.
function shuffleGroup(floes) {
  // Each floe carries its own shape (viewBox + polygon points + display
  // size) as a unit, so shapes can swap slots within the pool without
  // distortion or breaking that pool's no-overlap vertical spacing.
  const shapes = floes.map((floe) => {
    const svg = floe.querySelector('svg');
    const polygon = floe.querySelector('polygon');
    return {
      viewBox: svg.getAttribute('viewBox'),
      points: polygon.getAttribute('points'),
      width: floe.style.width,
      height: floe.style.height,
    };
  });

  shuffle(shapes);

  floes.forEach((floe, i) => {
    const shape = shapes[i];
    const svg = floe.querySelector('svg');
    const polygon = floe.querySelector('polygon');
    svg.setAttribute('viewBox', shape.viewBox);
    polygon.setAttribute('points', shape.points);
    floe.style.width = shape.width;
    floe.style.height = shape.height;
  });
}

function randomizeContainer(container) {
  const floes = Array.from(container.querySelectorAll('.seal-floating-ice__floe'));
  const pools = new Map();
  floes.forEach((floe) => {
    const pool = floe.dataset.pool || 'default';
    if (!pools.has(pool)) pools.set(pool, []);
    pools.get(pool).push(floe);
  });
  pools.forEach(shuffleGroup);
}

document.querySelectorAll('.seal-floating-ice').forEach(randomizeContainer);
